import { QueryClient } from '@tanstack/react-query';

import { ApiError, NetworkError, type RequestError } from './http';

declare module '@tanstack/react-query' {
  interface Register {
    /** Toda query e mutation falha com um dos erros tipados de `services/http.ts`. */
    defaultError: RequestError;
  }
}

/** Tentativas além da primeira, para falha que pode passar sozinha. */
const MAX_RETRIES = 2;

/**
 * Tenta de novo só o que pode dar certo na segunda vez: rede instável e erro 5xx (a API
 * reiniciando, o banco fora por um instante). 4xx e resposta fora do contrato se repetem
 * igual, e insistir só atrasa a mensagem de erro.
 */
export function shouldRetry(failureCount: number, error: RequestError): boolean {
  if (failureCount >= MAX_RETRIES) {
    return false;
  }

  if (error instanceof ApiError) {
    return error.status >= 500;
  }

  return error instanceof NetworkError;
}

/**
 * O cliente do React Query da aplicação — instanciado uma vez em `app/App.tsx`, e um novo
 * a cada teste (`test/renderWithProviders.tsx`), para o cache de um não vazar no outro.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 1 minuto sem refazer a chamada ao trocar de tela ou voltar à aba. Escala muda
        // por ação de pessoas (confirmação, troca), então o dado envelhece rápido, mas não
        // a ponto de justificar uma chamada por clique. Ajuste por query quando precisar.
        staleTime: 60 * 1000,
        retry: shouldRetry,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
